export default __webpack_public_path__ + "static/media/energy_saver_1.816f7841.png";